import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'
import getUnixTime from 'date-fns/getUnixTime'
import fromUnixTime from 'date-fns/fromUnixTime'

const APP_TIMEZONE = process.env.VUE_APP_TIMEZONE || 'Europe/Berlin'

/**
 * Returns the current date/time in the application's timezone.
 * Use with date-fns functions (startOfDay, startOfWeek, etc.)
 * then convert back with appGetUnixTime().
 */
export function appNow() {
    return utcToZonedTime(new Date(), APP_TIMEZONE)
}

/**
 * Converts a "zoned" Date (from appNow() + date-fns calculations)
 * back to a correct unix timestamp.
 *
 * Usage:
 *   appGetUnixTime(startOfDay(appNow()))
 *   // gives the unix timestamp for "start of today in Europe/Berlin"
 */
export function appGetUnixTime(zonedDate) {
    return getUnixTime(zonedTimeToUtc(zonedDate, APP_TIMEZONE))
}

/**
 * Converts a unix timestamp to a "zoned" Date in the application's timezone.
 * Use this instead of fromUnixTime() so that date-fns formatting functions
 * read the correct Berlin calendar date regardless of browser timezone.
 */
export function appFromUnixTime(timestamp) {
    return utcToZonedTime(fromUnixTime(timestamp), APP_TIMEZONE)
}

export { APP_TIMEZONE }
